export const RATE_LIMIT_MESSAGE = "Too many requests — please wait a moment and try again."

export const isRateLimited = error => Boolean(error) && error.status === 429
